import axios from "axios";

import apiConfig from "./apiConfig";

const api = axios.create({
  baseURL: apiConfig.animeUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(async (config) => config);

api.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }
    console.log(response);

    return response;
  },
  (error) => {
    throw error;
  }
);

export default api;
